import script from "./AgentStepVoice.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentStepVoice.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import PillRadioGroup from "@/components/neue/wizard/PillRadioGroup.vue";
import ToggleRow from "@/components/neue/wizard/ToggleRow.vue";
import WizardSection from "@/components/neue/wizard/WizardSection.vue";
script.components = Object.assign({}, { PillRadioGroup, ToggleRow, WizardSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { PillRadioGroup, ToggleRow, WizardSection }, script.__o.components);}